/**
 * The words of the message that starts an automation's run in Casey's chat.
 * The backend still seeds runs as `Run the skill **Title** on this case.`
 * (asterisks and "skill"); the chat shows and sends plain "automation"
 * wording instead, and reads messages stored with the old wording the same
 * way. Stored data is never rewritten.
 */

/** The first line of a run's thread: `Run the automation "Title" on this case.` */
export const skillRunLine = (title: string): string =>
  `Run the automation "${title}" on this case.`;

const LEGACY_RUN_LINE = /^Run the skill \*\*(.+?)\*\* on this case\./;

/** What the backend adds to a run's message about who started it. */
const LEGACY_SCHEDULE_NOTE = "started by the skill's schedule";

/** A run's seed or stored message in the plain wording; anything else is returned as is. */
export const plainSkillRunText = (text: string): string => {
  const match = LEGACY_RUN_LINE.exec(text);
  if (!match) return text;
  return (
    skillRunLine(match[1]) +
    text
      .slice(match[0].length)
      .replace(LEGACY_SCHEDULE_NOTE, "started by the automation's schedule")
  );
};
